<template>
  <div class="circle-single">
    <div class="circle-content circle-content--default chart fade-in">
      <lazy-img :src="step.image" class="circle-content__img" />
      <RadarChart class="chart__radar" :list="list"></RadarChart>
      <div class="summary-view__center">
        {{ $t(getFormData.amount[0]) }}
      </div>
      <div class="circle-content__title chart__title fade-in" v-html="$t(step.title)"></div>
    </div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default new Circle(Steps.SUMMARY, {
  methods: {  
    calcAverage(list, key) {
      const average = list[key].reduce((a, b) => (a + b)) / this.listLength;
      return 100 * average / this.max[key];
    },
    roastin(arr) {
      let roastin = 0;
      switch (arr.roastin) {
        case 'hipster':
          roastin = 50;
          break;
        case 'bright':
          roastin = 70;
          break;
        case 'dark':
          roastin = 100;
          break;
      }
      return roastin;
    }
  },
  computed: {
    max() {
      return this.$store.state.coffee.group_intensity;
    },
    listLength() {
      return this.$store.getters.getSelectedCoffeeListWithPercent.length;
    },
    averaging() {
      let averaging = {
        aroma: [],
        flavour: [],
        acidity: [],
        aftertaste: [],
      };
      this.$store.getters.getSelectedCoffeeListWithPercent.forEach(item => {
        averaging.aroma.push(item.group_intensity.aroma);
        averaging.flavour.push(item.group_intensity.flavour);
        averaging.acidity.push(item.group_intensity.acidity);
        averaging.aftertaste.push(item.group_intensity.aftertaste);
      });
      return averaging;
    },
    list() {   
      if (!this.listLength) {
        return [];
      }

      const formData = this.getFormData;
      const arr = this.averaging;

      return [
        {
          label: this.$t('roastin.step'),
          value: this.roastin(formData)
        },
        {
          label: this.$t('acidity.step'),
          value: this.calcAverage(arr, 'acidity')
        },
        {
          label: this.$t('flavour.step'),
          value: this.calcAverage(arr, 'flavour')
        },
        {
          label: this.$t('aftertaste.step'),
          value: this.calcAverage(arr, 'aftertaste')
        },
        {
          label: this.$t('aroma.step'),
          value: this.calcAverage(arr, 'aroma')
        }
      ];
    }
  }
}).comp;
</script>

<style lang="scss">
.summary-view__center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -30px;

  font-size: 2em;
  font-weight: bold;
  line-height: 1;
}

.chart {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.chart__radar {
  position: absolute;
  top: 2.5vw;
  left: 7.5%;
  right: 7.5%;
  height: 68%;
}

.chart__title {
  font-size: 5em;
  text-shadow: 0 0 20px $brownMedium, 0 0 10px $brownMedium,
    0 0 5px $brownMedium;
}

@media (min-width: 390.89px) {
  .chart__radar {
    top: 5vw;
  }
}

@media (min-width: 460.89px) {
  .chart__radar {
    top: 20px;
    left: 30px;
    right: 30px;
    height: 75%;
  }

  .chart__title {
    font-size: 40px;
  }

  .summary-view__center {
    margin-top: -20px;
  }
}

@media (min-width: 992.89px) {
  .chart__radar {
    top: 30px;
    height: 80%;
  }

  .summary-view__center {
    margin-top: -10px;
  }
}
</style>
